import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Popover from "react-bootstrap/Popover";

const Popup = ({placement="top", title, textLines=[], buttonClass, icon, iconClass, textButton}) => {
    return (
        <OverlayTrigger
            trigger="click"
            key="top"
            placement={placement}
            overlay={
                <Popover id={`popover-positioned-${placement}`}>
                    <dl>
                        <dt><b>{title}</b></dt>
                        {
                            textLines.map( (l, i) => <dd key={`popup-line-${i}`}>{l}</dd>)
                        }
                    </dl>
                </Popover>
            }
        >
            <Button className={buttonClass}>
                {
                    textButton && <p>{textButton}</p>
                }
                {
                    icon &&
                    <FontAwesomeIcon className={iconClass} icon={icon} />  
                }
            </Button>
        </OverlayTrigger>      
    )               
}

export default Popup;